// extracted by mini-css-extract-plugin
module.exports = {"chatNotice":"ChatNotice_chatNotice__-9sVt","content":"ChatNotice_content__EbOAc","dateTime":"ChatNotice_dateTime__1ciFm"};